import { register } from 'swiper/element/bundle';
import { StatusBar } from '@capacitor/status-bar';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { isIOS } from '@shared/utils/platform.utils';

register();

if (isIOS()) {
  StatusBar.setOverlaysWebView({ overlay: false });
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err: any) => console.error(err));
